export default __webpack_public_path__ + "static/media/Hund-auf-Zahlblöcken.87e14a2b.png";